module.exports = __webpack_public_path__ + "img/No-Favorite.6e736e25.png";